import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SidebarLeftCollapseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SidebarLeftCollapse",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.91 4s.09.04.09.09v23.83s-.04.09-.09.09H4.09S4 27.97 4 27.92V4.09S4.04 4 4.09 4h23.83m0-2H4.09C2.94 2 2 2.93 2 4.09v23.83c0 1.15.93 2.09 2.09 2.09h23.83c1.15 0 2.09-.93 2.09-2.09V4.09c0-1.15-.93-2.09-2.09-2.09m-8.23 19.75-6.15-5.8 6.04-5.7c.5-.48.53-1.27.05-1.77-.47-.5-1.26-.52-1.76-.05l-7 6.6c-.5.46-.53 1.24-.07 1.74.01.02.02.03.04.05.04.05.08.1.13.15l7 6.6c.24.22.55.34.86.34.33 0 .66-.14.91-.4.47-.5.45-1.29-.05-1.76"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.571 4.572H3.43A3.43 3.43 0 0 0 0 8v16a3.43 3.43 0 0 0 3.429 3.429H28.57A3.43 3.43 0 0 0 32 24V8a3.43 3.43 0 0 0-3.429-3.428M2.286 24V8c0-.63.513-1.142 1.143-1.142h4.637v18.285H3.43c-.63 0-1.143-.512-1.143-1.143m27.428 0c0 .631-.513 1.143-1.143 1.143H10.352V6.858h18.22c.63 0 1.142.512 1.142 1.142z"
      })
    })
  }));
};
SidebarLeftCollapseIcon.displayName = 'SidebarLeftCollapseIcon';